import { createFileRoute } from '@tanstack/react-router';

import { TasksPage, validateTasksSearch } from '../../features/tasks';

export const Route = createFileRoute('/_app/dashboard')({
  staticData: { crumbs: ['Мои задачи'] },
  // Клиент, чип статуса и страница живут в адресной строке - валидируем их здесь.
  validateSearch: validateTasksSearch,
  component: TasksPage,
});
